import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface CookiePreferences {
  functional: true;     // always required — cannot be disabled
  analytics: boolean;   // usage analytics (Plausible, etc.)
  marketing: boolean;   // retargeting, ads
}

interface CookieStore {
  decided: boolean;
  preferences: CookiePreferences;
  acceptAll: () => void;
  rejectNonEssential: () => void;
  setCustom: (prefs: Omit<CookiePreferences, 'functional'>) => void;
  reset: () => void;
}

const DEFAULTS: CookiePreferences = {
  functional: true,
  analytics: false,
  marketing: false,
};

export const useCookieStore = create<CookieStore>()(
  persist(
    (set) => ({
      decided: false,
      preferences: DEFAULTS,

      acceptAll: () => set({
        decided: true,
        preferences: { functional: true, analytics: true, marketing: true },
      }),

      rejectNonEssential: () => set({
        decided: true,
        preferences: { ...DEFAULTS },
      }),

      setCustom: (prefs) => set({
        decided: true,
        preferences: { functional: true, ...prefs },
      }),

      reset: () => set({ decided: false, preferences: DEFAULTS }),
    }),
    { name: 'aiphra-cookie-consent' }
  )
);
